import React, { useCallback, useEffect, useState } from 'react';
import { func, object, string, array } from 'prop-types';
import { isEmpty, isNil, equals, pluck, difference } from 'ramda';
import { connect } from 'react-redux';
import moment from 'moment';
import { Form } from 'antd';

import { handleRequestUpdateModal } from '../../redux/thunk/requests';
import StyledSelect from '../../components/ui-helpers/styled-select';
import { closeCurrentModal } from '../modal-reducer';

import { theme } from '../../styles';

import {
  FormContentWrapper,
  FormFieldAdd,
  FormFieldLabel,
  LabelSelectWrapper,
  FormFieldWrapper,
  RangeButtonWrapper,
  RangeInputContainer,
  StatusLog,
  StatusLogValue,
  SubTitle,
  TaskList,
  Title,
  FormAddTask,
  ModalButton,
  ModalButtonGradient,
  LabelHistoryWrapper,
  Label,
} from './styled-components';

import { SvgIcon } from '../../components/svg-icon';
import Attachments from '../../components/attachments';
import Task from '../../components/tasks-list/task';

import {
  getItemById,
  getItemByPath,
  validateFiles,
  formAttachmentsList,
  rejectedFilesErrors,
  validateNumberInput,
  validateNumbersRange,
  requestLabelsToOptions,
  requestSettingToOptions,
} from '../../utils';

import { BudgetContent } from './budget';
import { CommentContent } from './comment';
import { AddTaskContent, EditTaskContent } from './tasks';


export const changeStatusModalComponent = ({
  modal, form: {
    getFieldDecorator, getFieldsValue, setFields, validateFields, setFieldsValue, getFieldsError,
  },
  users,
  requests,
  closeModal,
  updateRequestAction,
  requestLabels: labels,
}) => {
  const {
    prevStatusColor, prevStatusValue, nextStatusColor, nextStatusValue, requestValue, requestId,
  } = modal.payload;

  const { budget } = requests.items[requestId];
  const requestBudget = budget || [];
  const request = getItemById(requestId, requests);
  const requestAssignees = request.assignees
    ? request.assignees.map(assignee => getItemByPath(['items', assignee], users))
    : null;
  const defaultRequestLabels = request.labels
    ? requestLabelsToOptions(request.labels.map(label => getItemByPath([label], labels)))
    : [];

  const [disableChangeBudgetBtn, setDisableChangeBudgetBtn] = useState(false);
  const [addBudget, setAddBudget] = useState(false);
  const [editBudget, setEditBudget] = useState(false);
  const [defaultBudget, setDefaultBudget] = useState(budget || []);
  const [addTask, setAddTask] = useState(false);
  const [editTask, setEditTask] = useState(false);
  const [addComment, setAddComment] = useState(false);
  const [editComment, setEditComment] = useState(false);
  const [commentText, setCommentText] = useState({ text: '', content: null });
  const [selectedRequestLabels, setSelectedRequestLabels] = useState(defaultRequestLabels);
  const [isRange, setIsRange] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [tasksList, setTasksList] = useState([]);
  const [taskId, setTaskId] = useState(null);
  const [changeLog, setChangeLog] = useState([false, false, false, false, false]);
  const [initialFiles, setInitialFiles] = useState({
    attachments: [],
    uploadedFiles: [],
  });

  // CHANGELOG
  const changes = changeLog.filter(Boolean).length;
  useEffect(() => {
    const budgetSum = requestBudget.reduce((acc, value) => acc + value, 0);
    const defaultBudgetSum = defaultBudget.reduce((acc, value) => +acc + +value, 0);

    if (defaultBudgetSum !== budgetSum) {
      setDisableChangeBudgetBtn(false);
    }
    setChangeLog([
      defaultBudgetSum !== budgetSum,
      tasksList.length > 0,
      commentText.text.length,
      initialFiles.attachments.length > 0,
      !equals(defaultRequestLabels, selectedRequestLabels),
    ]);
  }, [defaultBudget, tasksList, editComment, addComment, initialFiles, selectedRequestLabels]);

  // BUDGET
  useEffect(() => {
    if (defaultBudget.length > 0) {
      if (!isNil(defaultBudget[0])) {
        setAddBudget(true);
        setEditBudget(false);
        setDisableChangeBudgetBtn(true);
        if (!isNil(defaultBudget[1])) {
          setIsRange(true);
        }
      }
    }
  }, []);

  const minBudgetHandler = (event) => {
    setFields({
      min: {
        value: event.target.value,
      },
    });

    if (isRange) {
      validateFields(['max'], { force: true });
      const { min, max } = getFieldsValue(['min', 'max']);
      setErrorMessage(validateNumbersRange([min, max]));
    } else {
      const { min } = getFieldsValue(['min']);
      setErrorMessage(validateNumberInput(min));
    }
  };

  const maxBudgetHandler = (event) => {
    setFields({
      max: {
        value: event.target.value,
      },
    });
    validateFields(['min'], { force: true });

    const { min, max } = getFieldsValue(['min', 'max']);

    setErrorMessage(validateNumbersRange([min, max]));
  };

  const addBudgetHandler = (e) => {
    e.preventDefault();
    setAddBudget(true);
    setEditBudget(true);
  };

  const checkboxHandler = useCallback(() => {
    setIsRange(!isRange);
    if (!isRange) {
      const { min, max } = getFieldsValue(['min', 'max']);
      setErrorMessage(validateNumbersRange([min, max]));
    } else {
      const { min } = getFieldsValue(['min']);
      setDefaultBudget([+min]);
      setErrorMessage(validateNumberInput(min));
    }
  }, [isRange, setIsRange, getFieldsValue]);

  const budgetHandler = (e) => {
    e.preventDefault();
    const { min, max } = getFieldsValue();
    setDisableChangeBudgetBtn(false);
    if (!min) {
      setErrorMessage('Field is required');
      return null;
    }
    if (!errorMessage && min) {
      setDefaultBudget([+min, !isNil(max) ? +max : null]);
      setEditBudget(false);
    }
    return null;
  };

  const cancelBudget = (e) => {
    e.preventDefault();
    const budgetSum = requestBudget.reduce((acc, value) => acc + value, 0);
    const defaultBudgetSum = defaultBudget.reduce((acc, value) => +acc + +value, 0);
    setDisableChangeBudgetBtn(true);
    if (defaultBudgetSum === budgetSum && isEmpty(budget)) {
      setAddBudget(true);
      setEditBudget(false);
      setAddBudget(false);
    } else if (requestBudget.length) {
      setAddBudget(true);
      setEditBudget(false);
      setDefaultBudget(requestBudget);
    } else {
      setAddBudget(false);
      setEditBudget(false);
      setDefaultBudget([]);
    }
  };

  // COMMENT
  const commentHandler = (e) => {
    e.preventDefault();
    setEditComment(false);
  };

  const addCommentHandler = (e) => {
    e.preventDefault();
    setAddComment(true);
    setEditComment(true);
  };

  const cancelCommentHandler = (e) => {
    e.preventDefault();
    setAddComment(false);
    setEditComment(false);
    setCommentText({ text: '', content: null });
  };

  const quillHandler = (content, delta, source, editor) => {
    const text = editor.getText(content);
    setCommentText({ text: text.trim(), content });
  };

  // TASKS
  const addTaskHandler = (e) => {
    e.preventDefault();
    setAddTask(true);
  };

  const handleTaskUpdate = (id) => {
    setTaskId(id);
    setEditTask(true);
  };

  const createOrUpdateTaskHelper = () => {
    const task = getFieldsValue(['description', 'dueDate', 'dueTime', 'title', 'userId', 'taskPriority']);
    task.dueTime = task.dueTime ? moment(task.dueTime).format() : '';
    task.dueDate = moment(task.dueDate).format();
    task.assignedTo = task.userId ? users.items[task.userId] : {};
    return task;
  };

  const createTask = (e) => {
    e.preventDefault();
    validateFields(['dueDate', 'title']);
    const { dueDate, title } = getFieldsError(['dueDate', 'title']);
    const task = createOrUpdateTaskHelper();
    if (!dueDate && !title) {
      setTasksList([...tasksList, task]);
      setAddTask(false);
    }
    return null;
  };

  const cancelCreateAndEditTask = (e) => {
    e.preventDefault();
    setAddTask(false);
    setEditTask(false);
  };

  const updateTask = (e) => {
    e.preventDefault();
    validateFields(['dueDate', 'title']);
    const { dueDate, title } = getFieldsError(['dueDate', 'title']);
    const task = createOrUpdateTaskHelper();
    if (!dueDate && !title) {
      tasksList.splice(taskId, 1, task);
      setTasksList([...tasksList]);
      setEditTask(false);
    }
    return null;
  };

  const handleTaskDelete = (id) => {
    const newTaskList = [...tasksList];
    newTaskList.splice(id, 1);
    setTasksList([...newTaskList]);
  };

  // LABELS
  const handleSelectRequestLabels = (selectedLabels) => {
    setSelectedRequestLabels(selectedLabels ? [...selectedLabels] : []);
  };

  // ATTACHMENTS
  const openFilePicker = (event) => {
    // activate file input by clicking on it
    event.target.nextElementSibling.click();
  };

  const onAttachmentsAdd = (event) => {
    const files = Array.from(event.target.files);
    const { acceptedFiles, rejectedFiles } = validateFiles(files);
    setInitialFiles({
      uploadedFiles: [...initialFiles.uploadedFiles, ...acceptedFiles],
      attachments: [...initialFiles.attachments, ...formAttachmentsList(acceptedFiles)],
    });
    rejectedFilesErrors(rejectedFiles);
    // reset input
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
  };

  const onAttachmentRemove = (_, _id, name) => {
    setInitialFiles({
      uploadedFiles: [...initialFiles.uploadedFiles.filter(i => i.name !== name)],
      attachments: [...initialFiles.attachments.filter(i => i._id !== _id)],
    });
  };

  const onDrop = (files, rejectedFiles) => {
    setInitialFiles({
      uploadedFiles: [...initialFiles.uploadedFiles, ...files],
      attachments: [...initialFiles.attachments, ...formAttachmentsList(files)],
    });
    rejectedFilesErrors(rejectedFiles);
  };

  // SUBMIT FORM
  const submitFormHandler = (e, onlyStatusChange = false) => {
    e.preventDefault();
    const data = new FormData();
    data.append('status', requestValue);
    if (onlyStatusChange) {
      updateRequestAction(requestId, data);
      return null;
    }

    const taskToSubmit = tasksList.map((task) => {
      const { userId, ...newObj } = task;
      newObj.assignedTo = userId;
      return newObj;
    });

    const budgetSum = requestBudget.reduce((acc, value) => acc + value, 0);
    const defaultBudgetSum = defaultBudget.reduce((acc, value) => +acc + +value, 0);
    const clearBudget = defaultBudget.filter(value => !isNil(value));
    if (defaultBudgetSum !== budgetSum) data.append('budget', JSON.stringify(clearBudget));
    if (commentText.content) data.append('comment', commentText.content);
    if (!equals(defaultRequestLabels, selectedRequestLabels)) data.append('labels', JSON.stringify(pluck('_id', selectedRequestLabels)));
    if (tasksList.length > 0) data.append('tasks', JSON.stringify(taskToSubmit));
    if (initialFiles.attachments.length > 0) initialFiles.uploadedFiles.map(file => (data.append('files', file)));

    closeModal();
    return updateRequestAction(requestId, data);
  };

  return (
    <RangeInputContainer>
      <Form onSubmit={submitFormHandler}>
        <FormContentWrapper>
          <Title>Status changing</Title>
          <SubTitle>You want to change status</SubTitle>
          <StatusLog>
            <StatusLogValue color={prevStatusColor}>
              {prevStatusValue}
            </StatusLogValue><SvgIcon type="rightArrow" />
            <StatusLogValue color={nextStatusColor}>
              {nextStatusValue}
            </StatusLogValue>
          </StatusLog>

          <FormFieldWrapper>
            <FormFieldLabel>Add budget:</FormFieldLabel>

            {addBudget ?
              (<BudgetContent {...{
                isRange,
                editBudget,
                cancelBudget,
                errorMessage,
                setEditBudget,
                budgetHandler,
                defaultBudget,
                checkboxHandler,
                minBudgetHandler,
                maxBudgetHandler,
                getFieldDecorator,
                disableChangeBudgetBtn,
                setDisableChangeBudgetBtn,
              }}
              />)
              :
              (<FormFieldAdd
                onClick={addBudgetHandler}
              >
                Add budget
              </FormFieldAdd>)
            }
          </FormFieldWrapper>
          <FormFieldWrapper>
            <FormFieldLabel>Comment:</FormFieldLabel>
            {addComment ?
              (<CommentContent {...{
                commentText,
                editComment,
                quillHandler,
                setEditComment,
                commentHandler,
                cancelCommentHandler,
              }}
              />)
              :
              (<FormFieldAdd onClick={addCommentHandler}>Add comment</FormFieldAdd>)}
          </FormFieldWrapper>
          <FormFieldWrapper>
            <FormAddTask
              changePosition={tasksList.length}
            >
              <FormFieldLabel>Tasks:</FormFieldLabel>
              <FormFieldAdd
                onClick={addTaskHandler}
                hideBtn={addTask || editTask}
              >Add task
              </FormFieldAdd>
            </FormAddTask>
            {/* eslint-disable-next-line no-nested-ternary */}
            {(addTask || editTask) ?
              (editTask ?
                (<EditTaskContent {...{
                  users,
                  taskId,
                  editTask,
                  tasksList,
                  updateTask,
                  setFieldsValue,
                  getFieldDecorator,
                  cancelCreateAndEditTask,
                }}
                />) : (<AddTaskContent {...{
                  users,
                  addTask,
                  createTask,
                  setFieldsValue,
                  requestAssignees,
                  getFieldDecorator,
                  cancelCreateAndEditTask,
                }}
                />))
              :
              (<React.Fragment>
                <TaskList display={tasksList.length}>
                  {tasksList.map((task, index) => (
                    <Task
                      {...task}
                      number={index + 1}
                      key={task._id}
                      _id={index}
                      handleTaskUpdate={handleTaskUpdate}
                      handleTaskDelete={handleTaskDelete}
                      hideActions
                    />
                  ))}
                </TaskList>
              </React.Fragment>)}
          </FormFieldWrapper>
          <FormFieldWrapper>
            <FormFieldLabel>Labels:</FormFieldLabel>
            <LabelSelectWrapper>
              <StyledSelect
                isMulti
                maxWidth="100%"
                isClearable={false}
                value={selectedRequestLabels}
                onChange={handleSelectRequestLabels}
                options={requestSettingToOptions(labels)}
              />
              {!equals(defaultRequestLabels, selectedRequestLabels) && (
                <React.Fragment>
                  {difference(defaultRequestLabels, selectedRequestLabels).length > 0 && (
                    <LabelHistoryWrapper
                      showBottomBorder={
                        difference(selectedRequestLabels, defaultRequestLabels).length > 0
                      }
                    >
                      <span>Removed labels:</span>
                      {difference(defaultRequestLabels, selectedRequestLabels)
                        .map(({ value, color }) => (
                          <Label bgColor={color}>{value}</Label>
                        ))}
                    </LabelHistoryWrapper>
                  )}
                  {difference(selectedRequestLabels, defaultRequestLabels).length > 0 && (
                    <LabelHistoryWrapper>
                      <span>Added labels:</span>
                      {difference(selectedRequestLabels, defaultRequestLabels)
                        .map(({ value, color }) => (
                          <Label bgColor={color}>{value}</Label>
                        ))}
                    </LabelHistoryWrapper>
                  )}
                </React.Fragment>
              )}
            </LabelSelectWrapper>
          </FormFieldWrapper>
          <Attachments
            {...{
              onDrop,
              onAttachmentRemove,
              onAttachmentsAdd,
              openFilePicker,
            }}
            minView
            attachments={initialFiles.attachments}
            wrapperStyles={{
              width: '100%', margin: '5px', padding: 'unset', borderTop: 'unset',
            }}
            inModal
          />
        </FormContentWrapper>

        <RangeButtonWrapper>
          <ModalButton
            backgroundColor={theme.colors.lightGreySilver}
            onClick={(e) => {
              e.preventDefault();
              closeModal();
            }}
          > Close
          </ModalButton>
          {changes > 0 ?
            (<React.Fragment>
              <ModalButton
                width={231}
                noActionBtn
                backgroundColor={theme.colors.white}
                type="submit"
                onClick={e => submitFormHandler(e, true)}
              > Change status with no action
              </ModalButton>

              <ModalButtonGradient
                disabled={addTask || editTask || editBudget || editComment}
                type="submit"
                onClick={submitFormHandler}
              > Submit {changes} change{changes > 1 && 's'}
              </ModalButtonGradient>
            </React.Fragment>) :
            (<ModalButton
              width={231}
              noActionBtn
              backgroundColor={theme.colors.white}
              type="submit"
              onClick={e => submitFormHandler(e, true)}
            > Change status with no action
            </ModalButton>)}
        </RangeButtonWrapper>
      </Form>
    </RangeInputContainer>
  );
};

changeStatusModalComponent.propTypes = {
  modal: object.isRequired,
  form: object.isRequired,
  users: object.isRequired,
  requestId: string.isRequired,
  closeModal: func.isRequired,
  updateRequestAction: func.isRequired,
  requestValue: string.isRequired,
  requests: object.isRequired,
  requestLabels: array.isRequired,
};

const mapDispatchToProps = dispatch => ({
  updateRequestAction: (requestId, modifier) =>
    dispatch(handleRequestUpdateModal(requestId, modifier)),
  closeModal: () => dispatch(closeCurrentModal()),
});

const mapStateToProps = ({
  modal,
  requests,
  users,
  organizationSettings: { items: { requestLabels } },
}) => ({
  modal,
  requests,
  users,
  requestLabels,
});

const component = connect(
  mapStateToProps,
  mapDispatchToProps,
)(changeStatusModalComponent);

export const ChangeStatusModal = Form.create({ name: 'modal_form' })(component);



// WEBPACK FOOTER //
// ./src/modals/change-status/index.js